import { Button, Col, Form, Input, Menu, Row, Select, Spin, Tabs } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './sba.css';
import { ENV } from '../utils/http'

import { editSba, fetchSba, save } from './sbaActions';

const SubMenu = Menu.SubMenu;
const TabPane = Tabs.TabPane;

const Option = Select.Option;
const FormItem = Form.Item;
const { TextArea } = Input;

class SbaComponent extends Component {

  state = {
    tab: 'past'
  };

  constructor(props) {
    super(props);
    this.beforeTextArea = React.createRef();
    this.afterTextArea = React.createRef();
  }

  componentDidMount() {
    this.props.dispatch(fetchSba(this.props.match.params.id));
  }

  onChange(value, attr) {
    let args = {};
    args[attr] = value;

    this.props.dispatch(editSba(args));
  }

  scrollToMatch(textAreaRef, text, key) {

    let matchPosition = text.indexOf(key);

    if (matchPosition < 0) {
      return;
    }

    textAreaRef.scrollTop = 0;
    textAreaRef.value = text.substring(0, matchPosition);
    let scrollTo = textAreaRef.scrollHeight - 50; // calculate scroll to end

    textAreaRef.value = text;

    textAreaRef.scrollTop = scrollTo;

  }

  onClickMenu = ({ key }) => {
    this.scrollToMatch(this.beforeTextArea.current.textAreaRef, this.props.before, key);
    this.scrollToMatch(this.afterTextArea.current.textAreaRef, this.props.after, key);
  }

  preview() {
    const qs = this.state.tab==='future'? '?framtida=true' : '';
    window.open(`${ENV.previewUrl}/lag/${this.props.id}/andringar${qs}`, '_blank');
  }

  changeFuture(tab) {
    this.setState({
      tab
    });
  }

  render() {

    return (
      <div style={styles.content}>
        <Spin spinning={this.props.loading}>
          {this.props.id > 0 &&
            <Row>
              <Col span={4} style={styles.index}>
                <Menu
                  onClick={this.handleClick}
                  mode="inline"
                >
                  {this.props.documentIndex.map((chapter) => {

                    if (chapter.children.length === 0) return (<Menu.Item onClick={this.onClickMenu} key={chapter.title}>{chapter.title}</Menu.Item>);

                    return (<SubMenu key={chapter.title} title={chapter.title} >

                      {chapter.children.map((child) => (
                        <Menu.Item onClick={this.onClickMenu} key={child.title}>{child.title}</Menu.Item>
                      ))}
                    </SubMenu>)
                  }
                  )}
                </Menu>

              </Col>
              <Col span={20}>
                <Row>
                  <Col span={12} style={styles.col}>
                    <span style={styles.colTitle}>Före</span>
                    <TextArea id='before-textarea' style={{ ...styles.beforeAfter, background: 'rgb(250,250,250)' }} readOnly={true} ref={this.beforeTextArea} defaultValue={this.props.before} onBlur={(e) => this.onChange(e.target.value, 'before')}></TextArea>
                  </Col>
                  <Col span={12} style={styles.col}>
                    <span style={styles.colTitle}>Efter</span>
                    <TextArea style={styles.beforeAfter} ref={this.afterTextArea} defaultValue={this.props.after} onBlur={(e) => this.onChange(e.target.value, 'after')}></TextArea>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} style={styles.col}>
                    <Tabs defaultActiveKey="past" onChange={(e) => this.changeFuture(e)}>
                      <TabPane tab="Ändringsfil" key="past">
                        <TextArea style={styles.change} defaultValue={this.props.content} onBlur={(e) => this.onChange(e.target.value, 'content')}></TextArea>
                      </TabPane>
                      <TabPane tab="Framtida ändringar" key="future">
                        <TextArea style={styles.change} defaultValue={this.props.contentFuture} onBlur={(e) => this.onChange(e.target.value, 'contentFuture')}></TextArea>
                      </TabPane>
                    </Tabs>
                  </Col>
                </Row>
              </Col>
            </Row>}
          <div style={styles.toolbar}>

            <Button icon="search" style={{ marginRight: 20 }} size="large" type="secondary" onClick={() => this.preview()} >Förhandsgranska</Button>
            <Button type='primary' style={{ width: 100 }} size='large' onClick={() => this.props.dispatch(save(this.props))} >Spara</Button>

          </div>
        </Spin>
      </div>
    )
  }
}


const mapStateToProps = (state) => ({
  loading: state.sba.loading,
  id: state.sba.id,
  before: state.sba.before,
  after: state.sba.after,
  content: state.sba.content,
  contentFuture: state.sba.contentFuture,
  documentIndex: state.sba.documentIndex
});

export default connect(mapStateToProps)(SbaComponent);



// WEBPACK FOOTER //
// ./src/sba/sbaComponent.js